import {
  EnrichmentAiPanel,
  EnrichmentApiPanel,
  EnrichmentBulkPanel,
  EnrichmentCrmPanel,
  EnrichmentLicensingPanel,
  EnrichmentManagedServicePanel,
} from 'features/enrichment/atoms/EnrichmentDeliveryPanels/EnrichmentDeliveryPanels';

export const WAYS_TO_ENRICH = [
  {
    label: '01 — Data licensing',
    title: 'License the full dataset',
    description: '600M+ company records delivered to S3, SFTP or flat files — synced daily, weekly or quarterly.',
    media: EnrichmentLicensingPanel,
  },
  {
    label: '02 — Self-serve',
    title: 'Upload your list',
    description:
      'Drop in a .csv, .txt or .xlsx. Match on company name, VAT, registration number, website or LinkedIn URL.',
    media: EnrichmentBulkPanel,
  },
  {
    label: '03 — Instant',
    title: 'Connect over API or MCP',
    description:
      'One request per record, at onboarding, in forms or inside KYB checks — REST for your backend, MCP for your agents.',
    media: EnrichmentApiPanel,
  },
  {
    label: '04 — Native apps',
    title: 'Enrich your CRM',
    description: 'Salesforce and HubSpot apps match your accounts to registry records and keep them refreshed.',
    media: EnrichmentCrmPanel,
  },
  {
    label: '05 — AI connectors',
    title: 'Enrich inside Claude or ChatGPT',
    description: 'Connect Global Database to your AI assistant and enrich in plain language, cited to the filing.',
    media: EnrichmentAiPanel,
  },
  {
    label: '06 — Managed service',
    title: 'Send us the file',
    description: 'Ten thousand rows or ten million. Our team runs the matching and returns the enriched dataset.',
    media: EnrichmentManagedServicePanel,
  },
] as const;
